<template>
<div id="fog">
    
    <remote-js src="skrollr.min.js"></remote-js>
    <div id="skrollr-body" style="min-width: 1px; position: relative; z-index: 0; top: -80px; height: 72000px;">
        <div class="containerf" style="background-color: rgb(199,218,231)">
            <img class="deer" src="static/fog/deer.png" data-0="left: 45%; top:35%; display: block;" data-1200="left: 45%; top:35%; display: block;" data-2000="left: 70%;top:60%; display: block;"  data-3100="left: 70%;top:60%; display: block;" data-4100="left: 63%; top: 10%; display: block;" data-12800="left: 63%; top: 10%; display: block;" data-12900="left: 48%; top: 35%; display: block;" data-13000="left: 35%; top: 60%; display: block;" data-13400="left: 15%; top: 50%; display: block;" data-14000="left: 15%; top: 70%; display: block;" data-14500="left: 60%; top: 73%; display: block;" data-36000="left: 60%; top: 73%; display: block;" data-37000="left: 35%; top: 65%; display: block;" data-53000="left: 35%; top: 65%; display: block;" data-54000="left: 58%; top: 70%; display: block;" data-62700="left: 58%; top: 70%; display: block;" data-63200="left: 32%; top: 70%; display: block;" data-64000="left: 32%; top: 70%; display: block;" data-64800="left: 40%; top: 10%; display: block;" data-65700="left: 40%; top: 10%; display: block;" data-66200="left: 42%; top: 20%; display: block;" data-67200="left: 42%; top: 20%; display: block;" data-67700="left: 45%; top: 32%; display: block;" data-72000="left: 45%; top: 32%; display: block;" data-72500="left: 55%; top: 50%; display: block;" data-73500="left: 55%; top: 50%; display: block;" data-74000="left: 72%; top: 55%; display: block;"  style="left: 45%; top:35%; display: block;">
            <img class="fourdeerfather" src="static/fog/section4/deerfather.png" data-15000="top: 58%; left: -100%; display: block;" data-15500="top: 58%; left: 25%; display: block;" data-36000="top: 58%; left: 25%; display: block;" data-37000="top: 50%; left: 22%; display: block;" data-53000="top: 50%; left: 22%; display: block;" data-54000="top: 55%; left: 33%; display: block;" data-62700="top: 55%; left: 33%; display: block;" data-63200="top: 55%; left: 55%; display: block;" data-64000="top: 55%; left: 55%; display: block;" data-64800="top: 0%; left: 18%; display: block;" data-65700="top: 0%; left: 18%; display: block;" data-66200="top: 10%; left: 20%; display: block;" data-67200="top: 10%; left: 20%; display: block;" data-67700="top: 20%; left: 27%; display: block;" data-72000="top: 20%; left: 27%; display: block;" data-72500="top: 40%; left: 35%; display: block;" data-73500="top: 40%; left: 35%; display: block;" data-74000="top: 40%; left: 60%; display: block;" style="top: 58%; left: -100%; display: block;">
            <Section1></Section1>
            <Section2></Section2>
            <Section3></Section3>
            <Section4></Section4>
            <Section5></Section5>
            <Section6></Section6>
            <Section7></Section7>
            <Section8></Section8>
            <!-- <Slide>
                <router-link to="/Section1">
                    <span>情緒勒索</span>
                </router-link>
                <a href="#section2">
                <span>什麼是情緒勒索？</span>
                </a>
                <a href="#section3">
                <span>三大概念</span>
                </a>
                <a href="#section4">
                <span>六大特徵</span>
                </a>
                <a href="#section5">
                <span>四種型態</span>
                </a>
                <a href="#section6">
                <span>兩類特質</span>
                </a>
            </Slide> -->
        </div>
    </div>
    
</div>
</template>

<script>
import { Slide } from 'vue-burger-menu'
import Section1 from '@/components/pages/fog/Section1'
import Section2 from '@/components/pages/fog/Section2'
import Section3 from '@/components/pages/fog/Section3'
import Section4 from '@/components/pages/fog/Section4'
import Section5 from '@/components/pages/fog/Section5'
import Section6 from '@/components/pages/fog/Section6'
import Section7 from '@/components/pages/fog/Section7'
import Section8 from '@/components/pages/fog/Section8'
export default {
    name: "Fog",
    components: {
        'remote-js': {
            render(createElement) {
                return createElement('script', {attrs: {type: 'text/javascript', src: this.src}});
            },
            props: {
                src: { type: String, required: true}
            }
        },
        Slide,
        Section1: Section1,
        Section2: Section2,
        Section3: Section3,
        Section4: Section4,
        Section5: Section5,
        Section6: Section6,
        Section7: Section7,
        Section8: Section8,

    },
    mounted () {
        this.$nextTick(() => {
        skrollr.init()
        console.log('bug1')
        })
    },
    
    beforeDestroy () {
        this.$nextTick(() => {
        let instance = skrollr.get()
        console.log('bug2')
        instance.destroy()
        console.log('bug2')
        })
    }
}
    let instance = skrollr.get()
    instance.destroy()
</script>


<style>
Slide{
    z-index: 10000;
}

#nav,nav,Slide{
    z-index:100000;
    /* background-color: #598392; */
} 

Footer{
    z-index:10000;
}
#fog{
    z-index:0;
    position:relative
}
#fog img{
    position: absolute;
}
#skrollr-body{
    width: 100%;
    height: 100%;
    z-index: 0;
}
.bm-burger-button{
    top:50%;
}
.scene {
    width: 100%;
    height: 100%;
    position: fixed;
    overflow: hidden;
}
.containerf{
    width: 100%;
    height: 100%;
    position: fixed;
}

.deer{
    height: 25%;
    z-index: 10000;
}
.fourdeerfather{
    height: 40%;
    z-index: 10000;
}

highlight{
    color: #E9CD4C;
}






</style>


// WEBPACK FOOTER //
// src/components/pages/Fog.vue